import { authFetch } from './fetch';
import {
  IDispatchByStatus,
  IDeviceByStatus,
  IDispatchByType,
  IDispatchByTypeSubtype,
  IDispatchByClosedStatus,
  IDispatchByDispatchGroup,
  IDispatchByCity,
  IDispatchByDistrict,
  IDispatchByDevice,
  IDispatchesByHours,
  IDispatchesByWeekday,
  IStatisticsFilters,
  IExportDispatchesFilters,
} from '~/interfaces/IStatistics';

export const getDispatchByStatus = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByStatus[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-status',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDeviceByStatus = async (
  filters: IStatisticsFilters
): Promise<readonly IDeviceByStatus[]> => {
  const response = await authFetch({
    url: '/statistics/device-by-status',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByType = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByType[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-type',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByTypeSubtype = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByTypeSubtype[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-type-subtype',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByClosedStatus = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByClosedStatus[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-closed-status',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByDispatchGroup = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByDispatchGroup[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-dispatch-group',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByCity = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByCity[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-city',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByDistrict = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByDistrict[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-district',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchByDevice = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchByDevice[]> => {
  const response = await authFetch({
    url: '/statistics/dispatch-by-device',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchesByHours = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchesByHours[]> => {
  const response = await authFetch({
    url: '/statistics/dispatches-by-hours',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const getDispatchesByWeekday = async (
  filters: IStatisticsFilters
): Promise<readonly IDispatchesByWeekday[]> => {
  const response = await authFetch({
    url: '/statistics/dispatches-by-weekday',
    method: 'POST',
    data: filters,
  });
  return response.data;
};

export const exportDispatches = async (
  filters: IExportDispatchesFilters
): Promise<Blob> => {
  const response = await authFetch({
    url: '/statistics/export-dispatches',
    method: 'POST',
    data: filters,
    responseType: 'blob',
  });
  return response.data;
};
